export default class ChangePassword {
  constructor() {
    this.password = ''
  }
}
